/* eslint-disable */
import React, { useState } from "react";
import { getData } from "utils/Gateway";

const SaveAddressModal = ({
  addressIndex,
  addressData,
  setAddressData,
  addressBlock,
  setaddressBlock,
  setaddressIndex,
}) => {
  // A single, internal state to manage all validation errors for the form.
  const [errors, setErrors] = useState({});

  // --- Form Validation ---
  const validateForm = () => {
    const newErrors = {};

    // Trim inputs to prevent saving just whitespace
    if (!addressData.name.trim()) {
      newErrors.name = "A name for the address is required (e.g., Home).";
    }
    if (!addressData.address.trim()) {
      newErrors.address = "A street address is required.";
    }
    if (!addressData.zipcode.trim()) {
      newErrors.zipcode = "A zipcode is required to fetch location details.";
    }
    if (!addressData.city.trim()) {
      newErrors.city = "City is a required field.";
    }
    if (!addressData.state.trim()) {
      newErrors.state = "State is a required field.";
    }
    if (!addressData.country.trim()) {
      newErrors.country = "Country is a required field.";
    }

    setErrors(newErrors);
    // Return true only if the newErrors object is empty
    return Object.keys(newErrors).length === 0;
  };

  // --- Event Handlers ---

  const addAddressBlockHandler = () => {
    setaddressBlock([...addressBlock, addressData]);
    closeModalHandler();
  };

  const editAddressBlockHandler = () => {
    const updatedList = [...addressBlock];
    updatedList[addressIndex] = addressData;
    setaddressBlock(updatedList);
    closeModalHandler();
  };

  // Main save handler that validates first
  const handleSave = () => {
    // If validation fails, do nothing further.
    if (!validateForm()) {
      return;
    }
    // If validation passes, proceed to save.
    if (addressIndex != null) {
      editAddressBlockHandler();
    } else {
      addAddressBlockHandler();
    }
  };

  // Reset all states on modal close
  const closeModalHandler = () => {
    setAddressData({
      name: "",
      address: "",
      city: "",
      state: "",
      country: "",
      zipcode: "",
      mapurl: "",
    });
    setErrors({}); // Clear all validation errors
    setaddressIndex(null);
  };

  /* function to fetch location from zip code */
  const getLocationFromZip = async (e) => {
    e.preventDefault();
    if (addressData.zipcode.trim() === "") {
      setErrors((prev) => ({
        ...prev,
        zipcode: "Please enter a zipcode first.",
      }));
      return;
    }
    try {
      // Corrected the Google Maps API URL
      const url = `https://maps.googleapis.com/maps/api/geocode/json?components=postal_code:${addressData.zipcode}&key=YOUR_API_KEY_HERE`; // Replace with your actual API key
      const response = await getData(url);
      if (response.status === "OK" && response.results.length > 0) {
        const result = response.results[0];
        const locationData = { city: "", state: "", country: "" };

        result.address_components.forEach((item) => {
          if (item.types.includes("locality")) {
            locationData.city = item.long_name;
          }
          if (item.types.includes("administrative_area_level_1")) {
            locationData.state = item.long_name;
          }
          if (item.types.includes("country")) {
            locationData.country = item.long_name;
          }
        });

        setAddressData((prevData) => ({
          ...prevData,
          ...locationData,
          mapurl: `https://maps.google.com/maps?q=${result.geometry?.location?.lat},${result.geometry?.location?.lng}`,
        }));
        // Clear validation errors for fetched fields
        setErrors((prev) => ({
          ...prev,
          zipcode: "",
          city: "",
          state: "",
          country: "",
        }));
      } else {
        console.log("No results found for that zipcode.");
        setErrors((prev) => ({
          ...prev,
          zipcode: "Could not find location. Please check the zipcode.",
        }));
      }
    } catch (error) {
      console.error("Error fetching location:", error.message);
      setErrors((prev) => ({
        ...prev,
        zipcode: "There was an error fetching the location.",
      }));
    }
  };

  // Generic input change handler
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setAddressData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    // Clear the specific validation error for the field being edited
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  return (
    <div
      className="modal fade"
      id="saveAddress"
      tabIndex="-1"
      aria-labelledby="saveAddressLabel"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-lg">
        <div className="modal-content bg-white border-0 rounded-15 shadow-lg">
          {/* Enhanced Header with Icon and Gradient Background */}
          <div className="modal-header bg-primary text-white px-4 py-3 border-bottom border-gray-300">
            <div className="d-flex align-items-center gap-3">
              <div className="icon-wrapper p-3 bg-white rounded-circle d-flex align-items-center justify-content-center">
                <span className="material-symbols-outlined text-primary fs-5 icon-md">
                  location_on
                </span>
              </div>
              <div>
                <h3
                  className="fw-bold fs-2 text-white mb-0"
                  id="saveAddressLabel"
                >
                  {addressIndex != null ? "Edit Address" : "Add New Address"}
                </h3>
                <p className="text-white fs-sm mb-0">
                  Manage your saved addresses.
                </p>
              </div>
            </div>
            <button
              type="button"
              className="btn-close p-2 bg-gray-200 rounded-circle shadow-sm border-0"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={closeModalHandler}
            ></button>
          </div>
          <div className="modal-body p-4">
            <div className="p-3 p-md-4 border border-gray-300 rounded-10 shadow-sm">
              <form onSubmit={(e) => e.preventDefault()} noValidate>
                {/* ------ Name ------ */}
                <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                  <label
                    className="d-block fs-sm fw-semibold mb-2 text-dark"
                    htmlFor="addressName"
                  >
                    Name
                  </label>
                  <input
                    id="addressName"
                    type="text"
                    name="name"
                    className={`form-control fs-sm shadow-none ${
                      errors.name ? "is-invalid" : "border border-gray-300"
                    }`}
                    value={addressData.name}
                    onChange={handleInputChange}
                    placeholder="e.g., Home, Office, Warehouse"
                  />
                  {errors.name && (
                    <div className="invalid-feedback fw-semibold">
                      {errors.name}
                    </div>
                  )}
                </div>

                {/* ------ Address ------ */}
                <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                  <label
                    className="d-block fs-sm fw-semibold mb-2 text-dark"
                    htmlFor="addressStreet"
                  >
                    Address
                  </label>
                  <input
                    id="addressStreet"
                    type="text"
                    name="address"
                    className={`form-control fs-sm shadow-none ${
                      errors.address ? "is-invalid" : "border border-gray-300"
                    }`}
                    value={addressData.address}
                    onChange={handleInputChange}
                    placeholder="e.g., 123 Main Street"
                  />
                  {errors.address && (
                    <div className="invalid-feedback fw-semibold">
                      {errors.address}
                    </div>
                  )}
                </div>

                {/* ------ Zipcode + Button ------ */}
                <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                  <label
                    className="d-block fs-sm fw-semibold mb-2 text-dark"
                    htmlFor="addressZipcode"
                  >
                    Zipcode
                  </label>
                  <div className="d-flex gap-2 align-items-center">
                    <div className="flex-fill">
                      <input
                        id="addressZipcode"
                        type="text"
                        name="zipcode"
                        className={`form-control fs-sm shadow-none ${
                          errors.zipcode
                            ? "is-invalid"
                            : "border border-gray-300"
                        }`}
                        value={addressData.zipcode}
                        onChange={handleInputChange}
                        placeholder="Enter zipcode"
                      />
                    </div>
                    <div className="flex-shrink-0">
                      <button
                        type="button"
                        className="btn btn-outline-primary"
                        onClick={getLocationFromZip}
                      >
                        Fetch Location by Zipcode
                      </button>
                    </div>
                  </div>

                  {errors.zipcode && (
                    <div className="invalid-feedback fw-semibold">
                      {errors.zipcode}
                    </div>
                  )}
                </div>

                {/* ------ City & State in Same Row ------ */}
                <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                  <div className="row">
                    <div className="col-md-6">
                      <label
                        className="d-block fs-sm fw-semibold mb-2 text-dark"
                        htmlFor="addressCity"
                      >
                        City
                      </label>
                      <input
                        id="addressCity"
                        type="text"
                        name="city"
                        className={`form-control fs-sm shadow-none ${
                          errors.city ? "is-invalid" : "border border-gray-300"
                        }`}
                        value={addressData.city}
                        onChange={handleInputChange}
                        placeholder="e.g., New York"
                      />
                      {errors.city && (
                        <div className="invalid-feedback fw-semibold">
                          {errors.city}
                        </div>
                      )}
                    </div>
                    <div className="col-md-6">
                      <label
                        className="d-block fs-sm fw-semibold mb-2 text-dark"
                        htmlFor="addressState"
                      >
                        State / Province
                      </label>
                      <input
                        id="addressState"
                        type="text"
                        name="state"
                        className={`form-control fs-sm shadow-none ${
                          errors.state ? "is-invalid" : "border border-gray-300"
                        }`}
                        value={addressData.state}
                        onChange={handleInputChange}
                        placeholder="e.g., California"
                      />
                      {errors.state && (
                        <div className="invalid-feedback fw-semibold">
                          {errors.state}
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* ------ Country ------ */}
                <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                  <label
                    className="d-block fs-sm fw-semibold mb-2 text-dark"
                    htmlFor="addressCountry"
                  >
                    Country
                  </label>
                  <input
                    id="addressCountry"
                    type="text"
                    name="country"
                    className={`form-control fs-sm shadow-none ${
                      errors.country ? "is-invalid" : "border border-gray-300"
                    }`}
                    value={addressData.country}
                    onChange={handleInputChange}
                    placeholder="e.g., United States"
                  />
                  {errors.country && (
                    <div className="invalid-feedback fw-semibold">
                      {errors.country}
                    </div>
                  )}
                </div>

                {/* ------ Map URL ------ */}
                <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                  <label
                    className="d-block fs-sm fw-semibold mb-2 text-dark"
                    htmlFor="addressMapUrl"
                  >
                    Map URL (Optional)
                  </label>
                  <input
                    id="addressMapUrl"
                    type="text"
                    name="mapurl"
                    className="form-control fs-sm shadow-none border border-gray-300"
                    value={addressData.mapurl}
                    onChange={handleInputChange}
                    placeholder="e.g., https://maps.google.com/..."
                  />
                </div>

                {/* ------ Submit Button ------ */}
                <div className="action d-flex justify-content-end pt-3 border-top mt-4">
                  <button
                    type="button"
                    className="btn btn-primary d-flex align-items-center gap-2"
                    onClick={handleSave}
                  >
                    <span className="material-symbols-outlined me-1">save</span>{" "}
                    Save Address
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SaveAddressModal;
